import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, CATEGORY_IMAGES } from "@/lib/api";

export default function Shop() {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCategories(data));
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: category ? { category } : {} })
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, [category]);

  const activeCat = categories.find((c) => c.slug === category);

  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="shop-page">
      <div className="mb-8">
        <h1 className="font-display text-4xl md:text-5xl font-bold text-slate-900">
          {activeCat ? activeCat.name : "Shop Autism Essentials"}
        </h1>
        <p className="text-slate-600 mt-2">{activeCat?.blurb || "Curated, family-tested, dropship-ready."}</p>
      </div>

      <div className="flex gap-3 flex-wrap mb-8">
        <Link to="/shop" data-testid="cat-filter-all" className={`flex items-center gap-2 pl-1 pr-4 py-1 rounded-full text-sm font-bold transition ${!category ? "bg-pink-500 text-white" : "bg-white ring-1 ring-pink-100 text-slate-700 hover:bg-pink-50"}`}>
          <span className="w-7 h-7 rounded-full bg-gradient-to-br from-pink-400 to-purple-400 grid place-items-center text-white text-[10px] font-bold">ALL</span>
          All
        </Link>
        {categories.map((c) => (
          <Link key={c.slug} to={`/shop/${c.slug}`} data-testid={`cat-filter-${c.slug}`}
            className={`flex items-center gap-2 pl-1 pr-4 py-1 rounded-full text-sm font-bold transition ${category === c.slug ? "bg-pink-500 text-white" : "bg-white ring-1 ring-pink-100 text-slate-700 hover:bg-pink-50"}`}>
            <img src={CATEGORY_IMAGES[c.slug]} alt="" loading="lazy" className="w-7 h-7 rounded-full object-cover ring-1 ring-white" />
            {c.name}
          </Link>
        ))}
      </div>

      {loading ? (
        <div className="text-slate-500">Loading products...</div>
      ) : products.length === 0 ? (
        <div className="text-slate-500">No products yet in this category.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {products.map((p) => (
            <Link key={p.product_id} to={`/product/${p.product_id}`} data-testid={`product-card-${p.product_id}`} className="card-soft overflow-hidden">
              <div className="aspect-square bg-pink-50 overflow-hidden">
                <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-4">
                <div className="text-sm font-semibold text-slate-900 line-clamp-2">{p.name}</div>
                <div className="text-pink-600 font-bold mt-2">${p.price.toFixed(2)}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
